type CustomReport = {
    type: string
    url: string
    body: unknown
}

function sendReport(url: string, report: CustomReport) {
    if ('sendBeacon' in navigator) {
        navigator.sendBeacon(url, new Blob([JSON.stringify([report])], { type: 'application/reports+json' }))
    }
}

type HistoryState = null | Record<string, unknown>

// FIRST LOOK INTO THIS DIAGRAM!
//
// https://developer.chrome.com/docs/web-platform/page-lifecycle-api#overview_of_page_lifecycle_states_and_events

function reportTabCrash() {
    sendReport('/reporting/tab-crash', {
        type: 'custom-crash',
        url: location.href,
        body: null,
    })
}

export function setupCrashTracking() {
    const stateKey = 'tabCrashDetection'
    const STARTED = 'started'

    // 1. read current state
    const state: HistoryState = typeof history.state === 'object' ? history.state : {}

    // 2. check if the tab has not gracefully closed
    if ('wasDiscarded' in document) {
        // 2.1. chrome has a special property "wasDiscarded" that indicates if the tab has crashed before
        if (document.wasDiscarded) {
            reportTabCrash()
        }
    } else if (state && state[stateKey] === STARTED) {
        // 2.2. for other browsers, we check the signs from history state
        reportTabCrash()
    }

    // 3. set the state to started
    history.replaceState({ ...state, [stateKey]: STARTED }, '')

    document.addEventListener('visibilitychange', () => {
        const prevState: HistoryState = typeof history.state === 'object' ? history.state : {}
        if (document.visibilityState === 'hidden') {
            // 4.1. if the tab is hidden, set the state to undefined to indicate "graceful" close, we are not interested in this tab anymore
            // NOTE: seems like history state is immutable at this stage in Chrome, but fortunately it works in Safari
            history.replaceState({ ...prevState, [stateKey]: undefined }, '')
        } else {
            // 4.2. if the tab is visible, resume the crash tracking by setting the state to "started"
            history.replaceState({ ...prevState, [stateKey]: STARTED }, '')
        }
    })

    // 5. if the tab is closed, set the state to undefined to indicate "graceful" close, we are not interested in this tab anymore
    // NOTE: seems like history state is immutable at this stage in Chrome, but fortunately it works in Safari
    window.addEventListener('pagehide', () => {
        const prevState: HistoryState = typeof history.state === 'object' ? history.state : {}
        history.replaceState({ ...prevState, [stateKey]: STARTED }, '')
    })
}
